import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { Box, Grid, Card, CardContent, Typography, Button, CircularProgress, TextField, MenuItem, Select, InputLabel, FormControl } from '@mui/material';
import { useParams } from 'react-router-dom';
import { styled } from '@mui/system';
import MarkEmailUnreadIcon from '@mui/icons-material/MarkEmailUnread'; // Suggestive icon




const API_URL = process.env.REACT_APP_API_URL;

const infoTextStyle = {
    fontSize: { xs: '0.85rem', sm: '1rem' },
    color: '#ccc',
    letterSpacing: 1.5,
    mb: 0.5,
    textAlign: 'left',
};

const RequestFromUsers = ({ userId, onLogout }) => {

    useEffect(() => {
        window.scrollTo(0, 0);  // Scroll to top when this page is loaded
    }, []);


    const { id } = useParams(); // Assuming you use params for teacher ID or some other context
    const [requests, setRequests] = useState([]);
    const [loading, setLoading] = useState(true);
    const [selectedPlatform, setSelectedPlatform] = useState('');
    const [meetingLink, setMeetingLink] = useState('');

    useEffect(() => {
        axios.get(`${API_URL}/get_requests_for_teacher/`, {
            params: { teacher_id: userId },
        })
            .then(response => {
                setRequests(response.data);
                setLoading(false);
            })
            .catch(error => {
                console.error('Error fetching requests:', error);
                setLoading(false);
            });
    }, [userId]);

    const handleAccept = (requestId) => {
        axios.post(`${API_URL}/accept_request/`, {
            request_id: requestId,
            platform: selectedPlatform,
            meeting_link: meetingLink
        })
            .then(response => {
                setRequests((prevRequests) =>
                    prevRequests.map((request) =>
                        request.id === requestId ? {
                            ...request,
                            status: 'Accepted',
                            platform: selectedPlatform,
                            meeting_link: meetingLink
                        } : request
                    )
                );
            })
            .catch(error => {
                console.error('Error accepting request:', error);
            });
    };

    const handleReject = (requestId) => {
        axios.post(`${API_URL}/reject_request/`, { request_id: requestId })
            .then(response => {
                setRequests((prevRequests) =>
                    prevRequests.map((request) =>
                        request.id === requestId ? { ...request, status: 'Rejected' } : request
                    )
                );
            })
            .catch(error => {
                console.error('Error rejecting request:', error);
            });
    };

    return (
        <Box sx={{
            padding: { xs: 2, sm: 3, md: 4 },
            backgroundColor: '#000000',
            minHeight: '100vh',
            textAlign: 'center',
        }}>
            {loading ? (
                <CircularProgress sx={{ display: 'block', margin: 'auto', paddingTop: '50px', color: '#fff' }} />
            ) : (
                <Grid container spacing={{ xs: 7, sm: 10, md: 13, lg: 15 }} justifyContent="center">
                    {requests.length > 0 ? (
                        requests.map((request) => (
                            <Grid item
                                xs={12}
                                sm={6}
                                md={4}
                                lg={3}
                                xl={2}
                                key={request.id}>
                                <Link to={`/request-from-user-tab-details/${request.id}/${request.student_id}`} style={{ textDecoration: 'none' }}>
                                    <StyledCard
                                        sx={{
                                            height: '100%',
                                            display: 'flex',
                                            flexDirection: 'column',
                                            justifyContent: 'space-between',
                                            padding: 2,
                                        }}
                                    >
                                        <CardContent>
                                            <Typography
                                                variant="h6"
                                                component="h1"
                                                sx={{
                                                    fontSize: { xs: '1rem', sm: '1.2rem' },
                                                    fontWeight: 'bold',
                                                    color: '#fff',
                                                    letterSpacing: 2,
                                                    mb: 1,
                                                    textAlign: 'left',
                                                }}
                                            >
                                                {request.topic.length > 20 ? `${request.topic.substring(0, 20)}...` : request.topic}
                                            </Typography>

                                            <Typography sx={infoTextStyle}>
                                                📅 Date: {request.date} | 🕒 {request.time}
                                            </Typography>
                                            <Typography sx={infoTextStyle}>
                                                🗣️ Language: {request.language}
                                            </Typography>

                                            <Typography sx={infoTextStyle}>
                                                ⏱️ Duration: {request.duration} mins
                                            </Typography>
                                            <Typography sx={infoTextStyle}>
                                                🚦 Status: {request.status || 'Pending'}
                                            </Typography>

                                            {request.status === 'pending' && (
                                                <Box sx={{ marginTop: 1 }}>
                                                    <FormControl fullWidth sx={{ marginBottom: 2 }}>
                                                        <InputLabel sx={{ color: '#fff', letterSpacing: 1.5 }}>Select Platform</InputLabel>
                                                        <Select
                                                            value={selectedPlatform}
                                                            label="Select Platform"
                                                            onChange={(e) => setSelectedPlatform(e.target.value)}
                                                            sx={{
                                                                backgroundColor: '#333',
                                                                color: '#fff',
                                                                '.MuiSvgIcon-root': { color: '#fff' },
                                                                letterSpacing: 1.5,
                                                            }}
                                                        >
                                                            <MenuItem value="Google Meet">Google Meet</MenuItem>
                                                            <MenuItem value="Zoom">Zoom</MenuItem>
                                                            <MenuItem value="Microsoft Teams">Microsoft Teams</MenuItem>
                                                        </Select>
                                                    </FormControl>

                                                    <TextField
                                                        label="Meeting Link"
                                                        variant="outlined"
                                                        fullWidth
                                                        value={meetingLink}
                                                        onChange={(e) => setMeetingLink(e.target.value)}
                                                        sx={{
                                                            mb: 2,
                                                            backgroundColor: '#333',
                                                            input: { color: '#fff', letterSpacing: 1.5 },
                                                            label: { color: '#aaa' },
                                                        }}
                                                    />

                                                    <Box
                                                        sx={{
                                                            display: 'flex',
                                                            flexDirection: { xs: 'column', sm: 'row' },
                                                            gap: 2,
                                                        }}
                                                    >
                                                        <StyledButton
                                                            variant="contained"
                                                            color="primary"
                                                            sx={{ flex: 1, letterSpacing: 2 }}
                                                        >
                                                            Accept
                                                        </StyledButton>
                                                        <StyledButton
                                                            variant="outlined"
                                                            color="secondary"
                                                            sx={{ flex: 1, letterSpacing: 2, }}
                                                        >
                                                            Reject
                                                        </StyledButton>
                                                    </Box>
                                                </Box>
                                            )}
                                        </CardContent>
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            sx={{
                                                mt: 2,
                                                fontSize: { xs: '1rem', sm: '1.1rem' },
                                                padding: '10px 20px',
                                                borderRadius: '8px',
                                                letterSpacing: 2,
                                                backgroundImage: 'linear-gradient(45deg, #2196F3, #1976D2)',
                                                boxShadow: 4,
                                                '&:hover': {
                                                    backgroundImage: 'linear-gradient(45deg, #1976D2, #2196F3)',
                                                    boxShadow: 6,
                                                    transform: 'scale(1.03)',
                                                },
                                                transition: 'all 0.3s ease',
                                            }}
                                        >
                                            View
                                        </Button>
                                    </StyledCard>
                                </Link>
                            </Grid>
                        ))
                    ) : (
                        <Box
                            sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                padding: '3rem',
                                color: 'text.secondary',
                            }}
                        >
                            <MarkEmailUnreadIcon sx={{ fontSize: 50, mb: 2, color: '#ccc' }} />
                            <Typography
                                variant="h6"
                                sx={{
                                    textAlign: 'center',
                                    color: '#ccc',
                                    letterSpacing: 2,
                                    maxWidth: 500,
                                    mb: 1,
                                }}
                            >
                                Hey, you haven't received any requests yet!
                            </Typography>
                            <Typography
                                variant="body1"
                                sx={{
                                    textAlign: 'center',
                                    color: '#aaa',
                                    fontSize: '1rem',
                                    maxWidth: 500,
                                    letterSpacing: 2,
                                }}
                            >
                                Keep checking back here to see if someone has requested a session with you.
                            </Typography>
                        </Box>
                    )}
                </Grid>
            )}
        </Box>
    );
};

// Styled components
const StyledCard = styled(Card)(({ theme }) => ({
    maxWidth: '100%',
    minWidth: '300px',
    boxShadow: theme.shadows[5],
    borderRadius: 10,
    backgroundColor: '#111111', // Dark background for the card
    padding: theme.spacing(2),
    minWidth: '250px', // Minimum width to prevent cards from shrinking
    transition: 'all 0.3s ease-in-out',
    '&:hover': {
        boxShadow: theme.shadows[15],
        transform: 'translateY(-5px)',
    },
}));

const StyledButton = styled(Button)(({ theme }) => ({
    borderRadius: 5,
    textTransform: 'none',
    fontWeight: 600,
    padding: theme.spacing(1.5),
    boxShadow: theme.shadows[2],
    '&:hover': {
        boxShadow: theme.shadows[4],
    },
}));

export default RequestFromUsers;
